import { render, staticRenderFns } from "./TownList.vue?vue&type=template&id=62257510&scoped=true&"
import script from "./TownList.vue?vue&type=script&lang=js&"
export * from "./TownList.vue?vue&type=script&lang=js&"
import style0 from "./TownList.vue?vue&type=style&index=0&id=62257510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62257510",
  null
  
)

export default component.exports